/**
 * TanStack Query hooks for `influencer-channels`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	influencerChannelsQueryKeys,
	type CreateInfluencerChannelsBody,
	type ListInfluencerChannelsResponse,
	type InfluencerChannelsRow,
} from "./api";

export function useInfluencerChannelsList(): UseQueryResult<ListInfluencerChannelsResponse, Error> {
	return useQuery({
		queryKey: influencerChannelsQueryKeys.list(),
		queryFn: list,
	});
}

export function useInfluencerChannelsCreate(): UseMutationResult<InfluencerChannelsRow, Error, CreateInfluencerChannelsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: influencerChannelsQueryKeys.all });
		},
	});
}

export function useInfluencerChannelsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: influencerChannelsQueryKeys.all });
		},
	});
}
